import React from "react";
import "../style/Portfolio.css";
import Python from "../components/Python";
import Website from "../components/Website";
import { motion } from "framer-motion";

function Portfolio({ setMode }) {
  return (
    <motion.div
      className="portfolio_container"
      initial={{
        backgroundPosition: "center",
        backgroundRepeat: "no repeat",
        backgroundSize: "cover",
      }}
      style={{
        background: `url(${setMode[1]})`,
        color: setMode[0],
      }}
    >
      <div className="portfolio_head">
        <h1>PROJECTS</h1>
      </div>
      <div className="portfolio_body" syle={{ color: setMode[0] }}>
        <Python />
        <Website />
      </div>
    </motion.div>
  );
}

export default Portfolio;
